import React, { useState, useEffect } from 'react';
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  IconButton,
  Icon,
  Popover,
  ButtonGroup,
  LinearProgress,
  CircularProgress,
  Select,
  MenuItem,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { get, size, last, uniqBy, keyBy, flatten, set, first, take } from 'global/lib/lodash';
import SearchBar from 'global/components/SearchBar';
import Confirm from 'global/components/confirm';
import { getBase64Image, sortAlphaNum } from 'global/utils';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import sendData from 'redux/actions/sendData';
import clsx from 'clsx';
import highlightedText from 'global/components/highlight-text';
import { useStyles } from './styles';
import useDebounce from '../../hooks/useDebounce';
import Styles, { useScreen } from 'global/styles';
import CheckBoxOutlineBlankOutlined from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBox from '@mui/icons-material/CheckBox';
import { cleanCopy, downloadImage, stopProp, _size } from '../../utils';
import { awaitAll } from '../../utils/awaitAll';
import { Button } from '../Button';
import colors from '../../styles/colors';
import { Loader } from '../../styles';
import { PopContainer } from '../more-drop';
import { getRealmIcon } from '../droprealms';
import FolderIcon from '@mui/icons-material/Folder';
import qs from 'qs';
import { pressedKeys } from '../../utils/keytracker';
import { useIntersect } from '../../hooks/useIntersect';
import { PhotosGrid } from '../perform-grid';
import SnackAlerts from '../snack-alerts';
import NavToTop from '../../../feature/nav/NavToTop';
import { Media } from '../Media';
import { Text } from '../text';
import { Checkbox } from '../checkbox';
import { useSocket } from '../../hooks/useSocket';
import { useUser } from '../../hooks/useUser';
import { unset } from 'lodash';

const defaultUpdates = {
  quality: undefined,
  location: 0,
  supersets: [],
  somethingChanged: false,
};

const takeAdd = 20;

const ImageGrid = ({ supersets = [], realms = [], ...props }) => {
  const { userCanEdit, uploadPhotos, download, loading, canWallterSubscore, handleWallterAutoTag } = props;
  const folders = get(props, 'folders', []);
  const includeSearch = get(props, 'includeSearch', false);
  let [chosenFolders, setChosenFolders] = useState([]);
  const [items, _setItems] = useState([]);
  const [allItems, _setAllItems] = useState([]);
  const [popOpen, setPopOpen] = useState();
  const [confirm, setConfirm] = useState();
  const [dlStats, setDlStats] = useState();
  const [searchVal, setSearchVal] = useState('');
  const [alerts, setAlerts] = useState();
  const [wallterLoading, setWallterLoading] = useState(false);
  const [takeAmt, setTakeAmt] = useState(takeAdd);
  const [searchStat, setSearchStat] = useState({ isSearching: false, hasSearched: false });
  const [selected, setSelected] = useState({});
  const [filts, setFilts] = useState({
    cat: 'location',
    tag: undefined,
  });
  const [updates, _setUpdates] = useState(cleanCopy(defaultUpdates));
  const styles = Styles();
  const classes = useStyles();
  const debouncedSearch = useDebounce(searchVal, 750);
  const [ref, entry] = useIntersect({});
  const [btnRef, btnEntry] = useIntersect({});
  const inView = get(entry, 'isIntersecting', false);
  const [ctxtBtnsFixed, setCtxtBtnsFixed] = useState(false);
  const [listOpen, setListOpen] = useState(false);
  const [allphotos, setAllPhotos] = useState([]);
  const [state, setState] = useState({
    showNot: false,
  });

  const { isMobile } = useScreen();
  const { me } = useUser();
  const userId = get(me, 'id');

  const catOptions = [
    { title: 'By Location', id: 'location' },
    { title: 'By System', id: 'system' },
  ];

  const isFolders = get(items, '0.photos');

  const setItems = (its, sort = true) => {
    const it = uniqBy(its, 'id');
    _setItems(sort ? it.sort(sortAlphaNum) : it);
  };

  useEffect(() => {
    setCtxtBtnsFixed(!btnEntry.isIntersecting);
  }, [btnEntry.isIntersecting]);

  // This minor delay makes the following hook get called only after items are rendered.
  // It makes inView (bool visibility of the observer) more accurate when it's called.
  const _takeAmt = useDebounce(takeAmt, 50);
  useEffect(() => {
    if (takeAmt == 0 || (!loading && inView && takeAmt < size(items))) {
      setTakeAmt(takeAmt + takeAdd);
    }
  }, [inView, _takeAmt]);

  const setAllItems = (its) => {
    _setAllItems(uniqBy(its, 'id'));
    setTakeAmt(0);
  };

  const filterTaggedItems = (its = allItems, setTheItems = true) => {
    const _items = its.filter((it) => {
      if (it.photos) {
        return loading ? false : true;
      }
      let passes = true;
      if (filts.tag !== undefined && !get(it, 'divider')) {
        const itemQual = get(it, 'quality');
        passes = filts.tag === 'both' ? itemQual !== null : itemQual === filts.tag;
      }
      return passes;
    });

    if (setTheItems) {
      setItems(_items, false);
    } else {
      return _items;
    }
  };

  useEffect(() => {
    if (get(allItems, '0.photos')) {
      filterTaggedItems();
    }
  }, [allItems]);

  const setupFolders = (clear = false) => {
    let searchfor = folders;
    const allPhotos = flatten(folders.map((f) => f.photos));
    const isFiltered = debouncedSearch || filts.tag !== undefined;
    if (isFiltered) {
      setAllItems(allPhotos);
      setFilteredItems(allPhotos);
    } else if (filts.cat === 'system') {
      const map = keyBy(
        supersets.map((s) => ({ ...s, photos: undefined })),
        'id'
      );
      map['null'] = {
        realm: { name: 'None' },
        icon: FolderIcon,
        photos: [],
      };
      allPhotos.map((p) => {
        if (!size(p.supersets)) {
          set(map, ['null', 'photos'], [...get(map, ['null', 'photos'], []), p]);
        }
        (p.supersets || []).map((s) => {
          set(map, [s.id, 'realm'], s);
          set(map, [s.id, 'icon'], FolderIcon);
          set(map, [s.id, 'photos'], [...get(map, [s.id, 'photos'], []), p]);
        });
      });
      const its = Object.keys(map)
        .filter((k) => !!size(get(map, [k, 'photos'])))
        .map((k) => ({
          ...map[k],
          id: `realm-${k}`,
        }));
      setAllItems(its);
      // setStateFolders(its);
      setItems(its);
      setChosenFolders();
      searchfor = its;
    } else {
      const all = folders; // [ ...folders, { divider: { text: 'All Photos' } }, ...allPhotos ];
      setAllItems(all);
      setItems(all, false);
      setChosenFolders();
    }

    setAllPhotos(allPhotos);

    if (size(chosenFolders) && !clear) {
      const found = searchfor.find((f) => f.id === get(chosenFolders, '0.id'));
      !!found && clickImage(found, -1);
    }
  };

  useEffect(() => {
    setupFolders();
  }, [folders]);

  const updateSelected = async () => {
    const sel = Object.keys(selected)
      .filter((k) => selected[k])
      .map((k) => selected[k]);

    const results = await Promise.all(
      sel.map(async (item, index) => {
        try {
          const realm_id = updates.location != 0 ? get(updates, 'location', item.realm.id) : item.realm.id;
          const quality = get(updates, 'quality', item.quality);

          const relationships = {};

          const toSet = [];
          updates.supersets.map((s) => {
            if (s.all) {
              toSet.push({ type: 'supersets', id: s.id });
            } else if (!s.all && item.supersets.find((its) => its.id == s.id)) {
              toSet.push({ type: 'supersets', id: s.id });
            }
          });

          set(relationships, 'supersets.data', toSet);

          const data = {
            data: {
              type: 'realm-photos',
              id: item.id,
              attributes: {
                name: get(item, 'name'),
                assessment_id: get(item, 'assessment.id'),
                realm_id,
                quality,
                batchSize: size(sel),
                batchIndex: index,
              },
              relationships,
            },
          };

          const resp = await sendData(
            {
              url: `/realm-photos/${item.id}?${qs.stringify({ include: ['supersets', 'realm', 'assessment'].join(',') })}`,
              method: 'patch',
              data,
            },
            { normalize: { build: ['realmPhotos'] } }
          );
          return resp[0];
        } catch (err) {
          setAlerts({ message: `Patch failed: ${err.message}`, severity: 'error' });
        }
      })
    );
    if (size(results)) {
      await update();
      _setUpdates(cleanCopy(defaultUpdates));
      setSelected({});
      setState((s) => ({ ...s, showNot: false }));
      setAlerts({ message: 'Photo updates saved' });
    }
  };

  const setUpdates = (up) => {
    _setUpdates((u) => {
      const n = typeof up === 'function' ? up(u) : up;
      return {
        ...n,
        somethingChanged: true,
      };
    });
  };

  useEffect(() => {
    if (!listOpen && updates.somethingChanged) {
      updateSelected();
    }
  }, [updates, listOpen]);

  useEffect(() => {
    props.onSelectedChange && props.onSelectedChange(selected);
  }, [selected]);

  const clickImage = (img, index = 0) => {
    if (img.photos) {
      //is actually folder
      setItems(img.photos);
      setAllItems(img.photos);
      setChosenFolders([img]);
      if (index !== -1) {
        const upd = cleanCopy(defaultUpdates);
        _setUpdates(upd);
        setSelected({});
      } else if (_size(selected)) {
        //remove from selected images that are no longer in the set
        const sel = {};
        img.photos.map((p) => {
          if (selected[p.id]) {
            set(sel, p.id, p);
          }
        });
        setSelected(sel);
      }
    }
  };

  const clearFolder = (index) => {
    setDlStats((s) => ({ ...s, isLoading: true }));
    const folds = [...chosenFolders];
    folds.splice(index, 1);
    chosenFolders = folds;
    setChosenFolders(folds);
    setupFolders(true);
    setSelected({});
    setTakeAmt(takeAdd);
    setState((s) => ({ ...s, showNot: false }));

    setTimeout(() => {
      setDlStats((s) => ({ ...s, isLoading: false }));
    }, 500);
  };

  // const deleteImage = async (e, img) => {
  //   stopProp(e);
  //   const origItems = [...items];
  //   try {
  //     const itemIndex = items.findIndex((it) => it.id === img.id);
  //     items.splice(itemIndex, 1);
  //     const newItems = [...items];
  //     setItems(newItems);
  //     await sendData({
  //       url: `/realm-photos/${img.id}`,
  //       method: 'patch',
  //       data: {
  //         data: {
  //           id: img.id,
  //           type: 'realm-photos',
  //           attributes: {
  //             archived: true,
  //           },
  //         },
  //       },
  //     });
  //     update();
  //   } catch (err) {
  //     console.error(err);
  //     setItems(origItems);
  //     setAlerts({
  //       message: 'Delete Failed',
  //       severity: 'error',
  //     });
  //   }
  // };

  const selectImage = (e, img) => {
    stopProp(e);
    const shiftIsSelected = !!get(pressedKeys, '16');
    if (shiftIsSelected && !!_size(selected)) {
      const selIndexes = [];
      items.map((item, i) => {
        if (item.id == img.id || selected[item.id]) {
          selIndexes.push(i);
        }
      });
      const sorted = selIndexes.sort((a, b) => a - b);
      const newselected = {};
      for (let i = first(sorted); i <= last(sorted); i++) {
        const item = items[i];
        newselected[item.id] = item;
      }
      setSelected(newselected);
    } else {
      setSelected((s) => {
        if (s[img.id]) {
          unset(s, img.id);
        } else {
          set(s, img.id, img);
        }
        return { ...s };
      });
    }
  };

  const update = async () => {
    await get(props, 'update', () => 0)();
  };

  const folderOption = (e, folder, index) => {
    stopProp(e);
    setPopOpen({ index, anchor: e.currentTarget });
  };

  const setFilteredItems = (all = allItems) => {
    all = all.sort((a, b) => {
      const amt = size(a.supersets);
      const bmt = size(b.supersets);

      return amt - bmt;
    });
    let _items = [];
    const sups = {};
    const v = (debouncedSearch || '').toLowerCase();
    const checks = ['name', 'realm.name', ['photos', 'supersets.0.name'], ['photos', 'name']];
    const isSup = get(filts, 'cat') != 'location';

    const addAndCheck = (item) => {
      const cat = get(filts, 'cat') == 'location' ? 'realm' : 'supersets.0';

      if (isSup) {
        (!size(item.supersets) ? [{ id: -1, name: 'None' }] : item.supersets).map((s) => {
          const cf = get(chosenFolders, '0');
          if (cf && get(cf, 'systemId')) {
            if (get(cf, 'systemId') == s.id) {
              set(sups, s.id, { ...s, items: [...get(sups, [s.id, 'items'], []), item] });
            }
          } else {
            set(sups, s.id, { ...s, items: [...get(sups, [s.id, 'items'], []), item] });
          }
        });
        return;
      }

      const pastItem = last(_items);
      const pastFolder = get(pastItem, `${cat}.id`, 0);
      const thisFolder = get(item, `${cat}.id`, 0);
      if (pastFolder !== thisFolder || pastFolder === 0) {
        _items.push({ id: get(item, `${cat}.name`, 0), divider: { text: get(item, `${cat}.name`, 'None') } });
      }
      _items.push(item);
    };

    all.map((item) => {
      if (debouncedSearch) {
        for (let i = 0; i < checks.length; i++) {
          const c = checks[i];
          if (Array.isArray(c)) {
            // eslint-disable-next-line no-loop-func
            const [first, ...rest] = c;
            get(item, first, []).map((ii) => {
              const val = get(ii, ...rest, '').toLowerCase();
              if (val.indexOf(v) > -1) {
                addAndCheck({
                  ...ii,
                  parentFolder: {
                    ...item,
                  },
                });
              }
            });
          } else {
            if (get(item, c, '').toLowerCase().indexOf(v) > -1) {
              addAndCheck(item);
            }
          }
        }
      } else {
        addAndCheck(item);
      }
    });

    if (isSup) {
      Object.keys(sups).map((k) => {
        const its = filterTaggedItems(get(sups, [k, 'items'], []), false);
        if (size(its)) {
          const sub = get(sups, `${k}.name`, 'None');
          _items.push({ id: k, divider: { text: sub } });
          its.map((it) => _items.push({ ...it, sub }));
        }
      });
      _setItems(_items);
    } else {
      _items = _items.sort((a, b) => {
        const aPhotos = get(a, 'photos', []);
        const bPhotos = get(b, 'photos', []);
        return aPhotos.length > bPhotos.length ? -1 : 1;
      });

      if (filts.tag !== undefined) {
        filterTaggedItems(_items);
      } else {
        setItems(_items, false);
      }
    }

    setSearchStat({ isSearching: false, hasSearched: true });
  };

  const toggleNot = () => {
    const useNot = !state.showNot;

    if (useNot) {
      const notListed = allphotos.filter((a) => !items.find((it) => it.id == a.id));

      const cfname = get(chosenFolders, '0.name');

      _setItems([{ divider: { text: `Not ${cfname}` } }, ...notListed, { divider: { text: cfname } }, ...items]);
    } else {
      _setItems(get(chosenFolders, '0.photos', []));
    }

    setState((f) => ({ ...f, showNot: useNot }));
  };

  useEffect(() => {
    let _allItems = allItems;
    const isNotFiltered = !debouncedSearch && filts.tag === undefined;
    if (isFolders) {
      // This flattens the list of all items
      _allItems = uniqBy(flatten(items.map((it) => it.photos || [])), (a) => a.id);
      setAllItems(_allItems);
    }
    if (isNotFiltered && !get(chosenFolders, '0')) {
      setSearchStat({ isSearching: false, hasSearched: false });
      setupFolders(true);
      return setItems(_allItems, false);
    }

    setTakeAmt(takeAdd);
    setFilteredItems(_allItems);
  }, [debouncedSearch, filts]);

  useSocket(
    {
      channel: `wallter.${userId}`,
      onEvent: (data) => {
        setWallterLoading(false);
        setAlerts({ message: 'Auto-Tagging Complete', severity: 'success' });
        update();
      },
    },
    [`wallter.${userId}`]
  );

  const changeSearch = (val) => {
    setSearchVal(val);
    setSearchStat((ds) => ({ ...ds, isSearching: true }));
  };

  const closePop = (e) => {
    stopProp(e);
    setPopOpen();
  };

  const confirmDeleteAll = async (img) => {
    setDlStats((dl) => ({
      ...dl,
      isLoading: true,
      id: get(img, 'realm.id'),
      progress: 0,
    }));
    setConfirm();

    const files = get(img, 'photos', []);
    const failed = [];
    await awaitAll(
      files.map((p, index) => () => async () => {
        try {
          await sendData({
            url: `/realm-photos/${p.id}`,
            method: 'patch',
            data: {
              data: {
                id: p.id,
                type: 'realm-photos',
                attributes: {
                  archived: true,
                  batchSize: size(files),
                  batchIndex: index,
                },
              },
            },
          });
          setDlStats((dl) => ({
            ...dl,
            progress: dl.progress + 100 / files.length,
          }));
        } catch (err) {
          failed.push(p);
        }
      }),
      { queueSize: 10 }
    );

    setDlStats();

    if (failed.length > 0) {
      setAlerts({
        message: `These photos failed to delete: ${failed.map((f) => f.name).join(', ')}`,
        severity: 'error',
      });
    } else {
      setAlerts({
        message: 'Delete Success',
        severity: 'success',
      });
    }

    setSelected({});
    update();
  };

  const confirmDownload = async (img) => {
    setDlStats((dl) => ({
      ...dl,
      isLoading: true,
      id: get(img, 'realm.id'),
      progress: 0,
    }));
    setConfirm();

    const files = get(img, 'photos', []);

    if (size(files) === 1) {
      await downloadImage(files[0]);
      return setDlStats();
    }

    const b64Array = await Promise.all(
      files.map(async (f) => {
        try {
          const data = await getBase64Image(f.fullUrl);
          setDlStats((dl) => ({
            ...dl,
            progress: dl.progress + 100 / files.length,
          }));
          return {
            ...f,
            data,
          };
        } catch (err) {
          return null;
        }
      })
    );

    const zip = new JSZip();
    b64Array
      .filter((f) => f)
      .forEach((file) => {
        zip.file(file.name, file.data, { base64: true });
      });

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${get(img, 'realm.name', get(img, 'realm.id'))}-photos.zip`);
      setDlStats();
    });
  };

  const onDeleteSelected = (e) => {
    closePop(e);
    setConfirm({
      title: 'Delete Selected Images?',
      content: `Are you sure you want to delete the selected images?`,
      onOk: () =>
        confirmDeleteAll({
          realm: { id: 'selectedDelete' },
          photos: items.filter((item) => !!get(selected, item.id)),
        }),
      onCancel: () => setConfirm(),
    });
  };

  const onDeleteAll = (e, img) => {
    closePop(e);
    setConfirm({
      title: 'Delete All Images?',
      content: `Are you sure you want to delete all images in ${img.realm.name}?`,
      onOk: () => confirmDeleteAll(img),
      onCancel: () => setConfirm(),
    });
  };

  const onDownloadAll = (e, img) => {
    closePop(e);
    setConfirm({
      title: 'Download All Images?',
      content: `Are you sure you want to download all images in ${img.realm.name}?`,
      onOk: () => confirmDownload(img),
      onCancel: () => setConfirm(),
    });
  };

  const updateSuperset = (supe) => {
    let sups = [...get(updates, 'supersets', [])];
    const sui = sups.findIndex((s) => s.id == supe.id);
    const su = sups[sui];

    if (!su) {
      sups.push({ id: supe.id, all: true });
    } else if (get(su, 'all') == false) {
      set(sups, `${sui}.all`, true);
    } else {
      sups.splice(sui, 1);
    }
    setUpdates((u) => ({ ...u, supersets: sups }));
  };

  const renderChosen = () => {
    return (chosenFolders || []).map((cf, i) => (
      <Button key={cf.id} disableElevation size="small" onClick={() => clearFolder(i)} bgColor={colors.darkGrey}>
        <div className={classes.chosenFolder}>
          <p className={classes.cfTitle}>{get(cf, 'realm.name', '')}</p>
          <p className={classes.cfSize}>{`${size(items.filter((i) => !get(i, 'divider')))} photos`}</p>
          <IconButton className={classes.closeFolder} size="large">
            <Icon>close</Icon>
          </IconButton>
        </div>
      </Button>
    ));
  };

  const blankContent = () => {
    if (props.blankContent) {
      return props.blankContent();
    }

    return null;
  };

  const openList = () => {
    const sups = {};

    Object.keys(selected).map((k) => {
      const sel = selected[k];

      const selsupersets = sel.supersets;

      selsupersets.map((s) => set(sups, s.id, [...get(sups, s.id, []), s]));
    });

    const usets = [...get(updates, 'supersets', [])];
    Object.keys(sups).map((k) => {
      const val = sups[k];
      usets.push({ id: k, all: size(val) >= size(Object.keys(selected)) });
    });

    _setUpdates((u) => ({ ...u, supersets: usets }));
    setListOpen(true);
  };

  const closeList = () => {
    setListOpen(false);
    setTimeout(() => {
      _setUpdates(cleanCopy(defaultUpdates));
    }, 50);
  };

  const selectedSize = size(Object.keys(selected).filter((k) => selected[k]));

  const showCtxt = userCanEdit && !!selectedSize;

  const canSelect = userCanEdit || props.canSelect;

  const cols = isMobile ? 2 : 4;

  const folderIsSystem = !!get(chosenFolders, '0.systemId');

  const sortImgSupersets = (img) => {
    if (!img.supersets) {
      return null;
    }

    if (folderIsSystem) {
      const sysId = get(chosenFolders, '0.systemId');
      let newsets = [];

      img.supersets.map((s) => {
        if (s.id == sysId) {
          newsets = [s, ...newsets];
        } else {
          newsets.push(s);
        }
      });

      return newsets;
    }

    return img.supersets;
  };

  const handleWallterAutoTagRequested = () => {
    setWallterLoading(true);
    handleWallterAutoTag && handleWallterAutoTag();
    setAlerts({ message: 'Auto-Tagging in Progress...' });
  };

  return (
    <>
      {userCanEdit && !_size(selected) && (
        <div className={classes.buttonRow}>
          <Button className={classes.button} variant="contained" color="secondary" onClick={uploadPhotos} startIcon={<Icon>cloud_upload</Icon>}>
            {isMobile ? 'Upload' : 'Upload Photos'}
          </Button>
          <Button className={classes.button} variant="contained" color="secondary" onClick={download} startIcon={<Icon>cloud_download</Icon>}>
            {'Download'}
            {props.dlStats ? <CircularProgress variant="determinate" size={16} value={props.dlStats.progress} /> : null}
          </Button>
          {canWallterSubscore && (
            <Button className={classes.button} variant="contained" color="secondary" onClick={handleWallterAutoTagRequested} startIcon={<Icon>photo_filter</Icon>} loading={wallterLoading}>
              {'Auto-Tag'}
            </Button>
          )}
        </div>
      )}
      <div ref={btnRef} />
      {showCtxt && (
        <div className={clsx(classes.selectedRow, ctxtBtnsFixed && classes.selectRowFixed)}>
          <PhotosGrid>
            <div className={classes.row}>
              <IconButton onClick={() => setSelected({})} size="large">
                <Icon>close</Icon>
              </IconButton>
              <div>{`${selectedSize} Selected`}</div>
              <div className={classes.selButtonRow}>
                <PopContainer
                  icon="label"
                  onOpen={openList}
                  onClose={closeList}
                  title={
                    <>
                      <Icon style={{ marginRight: 5 }}>label</Icon>Update Tags
                    </>
                  }
                  options={supersets.map((r) => ({ title: r.name, selected: get(updates, 'supersets', []).indexOf(r.id) > -1, onClick: () => updateSuperset(r) }))}
                >
                  <div className="popContainer">
                    <div className="spaceVert">
                      <Text bold>Quality</Text>

                      <ToggleButtonGroup exclusive value={updates.quality} onChange={(e, q) => setUpdates((v) => ({ ...v, quality: q }))}>
                        <ToggleButton value={null}>
                          <Icon>close</Icon>
                        </ToggleButton>
                        <ToggleButton value={1}>
                          <Icon>thumb_up</Icon>
                        </ToggleButton>
                        <ToggleButton value={0}>
                          <Icon>thumb_down</Icon>
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </div>

                    <div className="spaceVert">
                      <Text bold>Location</Text>

                      <Select size="small" fullWidth placeholder={'Select a Location'} value={updates.location} onChange={(e) => setUpdates((v) => ({ ...v, location: e.target.value }))}>
                        <MenuItem value={0}>Any</MenuItem>
                        {realms.map((l) => (
                          <MenuItem value={l.id}>{l.name}</MenuItem>
                        ))}
                      </Select>
                    </div>

                    <div className="spaceVert">
                      <Text bold>System</Text>

                      <div>
                        {supersets.map((s) => (
                          <Checkbox
                            checkProps={{
                              size: 'small',
                              indeterminate:
                                get(
                                  updates.supersets.find((su) => su.id == s.id),
                                  'all'
                                ) == false,
                            }}
                            checked={
                              !!get(
                                updates.supersets.find((su) => su.id == s.id),
                                'all'
                              )
                            }
                            onChange={() => updateSuperset(s)}
                            label={s.name}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </PopContainer>
                <div className={classes.vr} />
                <Button
                  variant="contained"
                  onClick={() => confirmDownload({ realm: { id: `Selected-${new Date().toISOString()}` }, photos: items.filter((item) => !!get(selected, item.id)) })}
                  disableElevation
                  size="small"
                  startIcon={get(dlStats, 'id', '').indexOf('Selected-') > -1 ? <Loader size={14} /> : <Icon>save_alt</Icon>}
                  className={clsx(classes.selButton)}
                >
                  Download
                </Button>
                <div className={classes.vr} />
                <Button
                  variant="contained"
                  onClick={onDeleteSelected}
                  disableElevation
                  size="small"
                  startIcon={get(dlStats, 'id') === 'selectedDelete' ? <Loader size={14} /> : <Icon>delete</Icon>}
                  bgColor={colors.danger}
                  className={clsx(classes.selButton, classes.selDelete)}
                >
                  Delete
                </Button>
              </div>
            </div>
          </PhotosGrid>
        </div>
      )}

      {includeSearch && (
        <div className={classes.searchContainer} style={{ marginTop: showCtxt ? (isMobile ? 150 : 80) : undefined }}>
          <SearchBar onClear={() => changeSearch('')} loading={get(searchStat, 'isSearching', false)} searchString={searchVal} changeSearch={changeSearch} />
        </div>
      )}

      <div className={classes.foldersRow}>
        {!isMobile && renderChosen()}

        {!props.hideSuperset && (
          <Select className={styles.select} disableUnderline variant="filled" value={filts.cat} onChange={(e) => setFilts((f) => ({ ...f, cat: e.target.value }))}>
            {catOptions.map((l, i) => (
              <MenuItem key={i} value={get(l, 'id')}>
                {get(l, 'title')}
              </MenuItem>
            ))}
          </Select>
        )}
        <div className={classes.filterRow}>
          <Button
            bgColor={get(filts, 'tag') === undefined ? undefined : colors.lightGreyBorder}
            onClick={() => setFilts((f) => ({ ...f, tag: undefined }))}
            disableElevation
            size="small"
            variant="contained"
          >
            ALL
          </Button>
          <Button bgColor={get(filts, 'tag') === 1 ? undefined : colors.lightGreyBorder} onClick={() => setFilts((f) => ({ ...f, tag: 1 }))} disableElevation size="small" variant="contained">
            <Icon className={classes.pos}>thumb_up</Icon>
          </Button>
          <Button bgColor={get(filts, 'tag') === 0 ? undefined : colors.lightGreyBorder} onClick={() => setFilts((f) => ({ ...f, tag: 0 }))} disableElevation size="small" variant="contained">
            <Icon className={classes.neg}>thumb_down</Icon>
          </Button>
          <Button
            bgColor={get(filts, 'tag') === 'both' ? undefined : colors.lightGreyBorder}
            onClick={() => setFilts((f) => ({ ...f, tag: 'both' }))}
            disableElevation
            size="small"
            variant="contained"
          >
            <Icon>thumbs_up_down</Icon>
          </Button>
          <Button bgColor={get(filts, 'tag') === null ? undefined : colors.lightGreyBorder} onClick={() => setFilts((f) => ({ ...f, tag: null }))} disableElevation size="small" variant="contained">
            <Icon>cancel_presentation</Icon>
          </Button>

          {folderIsSystem && (
            <Button bgColor={state.showNot ? undefined : colors.lightGreyBorder} onClick={toggleNot} disableElevation size="small" variant="contained">
              Show All
            </Button>
          )}
        </div>
      </div>

      {isMobile && <div className={classes.foldersRow}>{renderChosen()}</div>}

      {(props.loading || get(dlStats, 'isLoading')) && <LinearProgress color="primary" />}
      <NavToTop visible={ctxtBtnsFixed} />
      <ImageList className={classes.gridList} cols={cols} gap={16}>
        {!get(searchStat, 'isSearching') &&
          !get(dlStats, 'isLoading') &&
          !props.loading &&
          take(items, takeAmt).map((img, i) => {
            const isFolder = get(img, 'photos');
            const prevImg = get(items, [i - 1]);
            const prevImage = get(prevImg, 'photos');
            const divide = !isFolder && prevImage && searchVal && !get(searchStat, 'isSearching');
            const divider = get(img, 'divider');
            const HasIcon = get(img, 'icon');
            const isSelected = !!get(selected, img.id);

            const imageSel = isSelected;

            return divider ? (
              <ImageListItem cols={cols} key={`divider_${i}`} className={classes.hrDivider}>
                <div>{divider.text}</div>
              </ImageListItem>
            ) : (
              <ImageListItem
                className={clsx(isFolder ? classes.gridListFolder : classes.gridTile, divide && classes.divider, imageSel && classes.gridTileSelected)}
                onClick={!!selectedSize ? (e) => selectImage(e, img) : () => (isFolder ? clickImage(img, i) : undefined)}
                key={img.id}
              >
                <>
                  {HasIcon ? (
                    <HasIcon className={classes.imgContainer} />
                  ) : (
                    <Media {...img} viewOnly={!userCanEdit} canEdit={!selectedSize} opt={'tag'} images={items} index={i} onClose={(s) => (s.hasEdits ? update() : () => 0)} />
                  )}

                  {!isFolder && (
                    <>
                      {canSelect && (
                        <IconButton
                          classes={{ root: classes.iconRoot }}
                          onClick={(e) => selectImage(e, img)}
                          className={clsx(classes.checkIcon, imageSel && classes.checkIconSelected, !!selectedSize && classes.checkIconSelectMode)}
                          size="large"
                        >
                          {imageSel ? <CheckBox /> : <CheckBoxOutlineBlankOutlined />}
                        </IconButton>
                      )}

                      <PhotoText img={{ ...img, supersets: sortImgSupersets(img) }} isSelected={imageSel} />
                    </>
                  )}

                  {isFolder && (
                    <ImageListItemBar
                      title={highlightedText(`${get(img, 'realm.name', '')}`, searchVal)}
                      subtitle={<span>{`${size(img.photos)} photos`}</span>}
                      classes={{ root: classes.titleBar }}
                      actionIcon={
                        !userCanEdit ? undefined : (
                          <>
                            {dlStats && dlStats.id === get(img, 'realm.id') ? (
                              <IconButton className={classes.icon} size="large">
                                <CircularProgress variant="determinate" size={22} value={dlStats.progress} />
                              </IconButton>
                            ) : (
                              <IconButton onClick={(e) => folderOption(e, img, i)} aria-label={`info about ${img.name}`} className={classes.icon} size="large">
                                <Icon>more_vert</Icon>
                              </IconButton>
                            )}
                            <Popover className={classes.popOver} open={get(popOpen, 'index') === i} anchorEl={get(popOpen, 'anchor')} onClose={closePop}>
                              <ButtonGroup orientation="vertical" variant="contained" color="secondary">
                                {userCanEdit && (
                                  <Button startIcon={<Icon>delete</Icon>} onClick={(e) => onDeleteAll(e, img)}>
                                    Delete All
                                  </Button>
                                )}
                                <Button startIcon={<Icon>cloud_download</Icon>} onClick={(e) => onDownloadAll(e, img)}>
                                  Download
                                </Button>
                              </ButtonGroup>
                            </Popover>
                          </>
                        )
                      }
                    />
                  )}
                </>
              </ImageListItem>
            );
          })}
        {!get(searchStat, 'isSearching') && size(items) === 0 && !props.loading && blankContent()}
        <Box sx={{ height: 20 }} ref={ref} />
      </ImageList>

      <Confirm {...confirm} />

      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </>
  );
};

const PhotoText = (props) => {
  const { img, isSelected } = props;
  const classes = useStyles();

  const style = get(props, 'style', {});

  const hasQuality = get(img, 'quality') !== null && get(img, 'quality') !== undefined;
  const isBp = hasQuality && img.quality === 1;

  let icon = hasQuality ? <Icon className={isBp ? 'pos' : 'neg'}>{isBp ? 'thumb_up' : 'thumb_down'}</Icon> : getRealmIcon(img.realm);
  let title = get(img, 'name');
  let subtitle = get(img, 'sub', img.supersets ? img.supersets.map((s) => s.name).join('; ') : get(img, 'realm.name'));

  return (
    <div id={'photoText'} className={clsx(classes.photoText, isSelected && classes.photoTextSelected)} style={style}>
      <div className="icon">{icon}</div>
      <div className="textContainer">
        <div className="title">{title}</div>
        {!!subtitle && <div className="subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default ImageGrid;
